import { render, staticRenderFns } from "./OpcionesDropdownComponent.vue?vue&type=template&id=4898427b&scoped=true"
import script from "./OpcionesDropdownComponent.vue?vue&type=script&lang=js"
export * from "./OpcionesDropdownComponent.vue?vue&type=script&lang=js"
import style0 from "./OpcionesDropdownComponent.vue?vue&type=style&index=0&id=4898427b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898427b",
  null
  
)

export default component.exports